<template>
  <div id="OpenApi" class="bg-color1" style="height:calc(100vh);">
    <div ref="app_head" class="col-12 lh40 bg-color-white b-s-2 pl5 pr5 fixed-t">
        <div class="col-3 f18" @click="$router.back(-1)"><i class="iconfont icon-31fanhui1 color-primary"></i></div>
        <div class="col-6 t-c color-primary"><span class="f24 fw">O</span>pen API {{ pageData.open_id }}</div>
        <div class="col-3 t-r f22 pr3"></div>
    </div>
    <div class="h4"></div>
    <div class="col-12 pt3 pb10 bg-color1" style="overflow-y: auto;">
      <div class="col-12 bb1" v-for="(cate,cate_i) in data_list" v-bind:key="cate_i" @click="select_on(cate_i)">
        <div class="col-12">
          <div class="col-12 bg-color-white p5">
              <div class="col-10 pl10 pt8">
                <div class="col-12 f14">{{ cate.cate_code }}</div>
                <div class="col-12 f14">{{ cate.cate_name }}</div>
              </div>
              <div class="col-2 color-muted t-r lh50 pr5">
                <i class="iconfont icon-checkbox-xuanzhong f22 color-primary" v-if="cate.status == 1"></i>
                <i class="iconfont icon-checkbox-weixuan f22 color-muted" v-else></i>
              </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'OpenApi',
  data () {
    return {
      data_list: [],
      pageData: {
        open_id: this.$route.query.open_id
      }
    }
  },
  created: function () {
    this.get_list_data();
  },
  methods: {
    get_list_data() {
      var post_data = {};
      post_data.open_id = this.pageData.open_id;
      this.post(this.api_url + 'manage/open_api_cate_list', post_data).then((res)=>{
        if(res.status == 1){
          console.log(res.data);
          this.data_list = res.data;
        }else{
          this.data_list = []
        }
      })
    },
    select_on(cate_i) {
      let post_data = {};
      post_data.open_id = this.pageData.open_id;
      post_data.cate_id = this.data_list[cate_i].id;
      post_data.status = this.data_list[cate_i].status;
      this.post(this.api_url + 'manage/open_api_cate_select', post_data).then((res)=>{
        if(res.status == 1){
          this.$store.commit('setAlert',{type:'success',msg: "Success"});
          this.get_list_data();
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Main/OpenApiCateList.vue